export const crmRouteDef = [
    {
        path: ':type/leave',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar',
            type:'leave_calendar'


        }
    },
    {
        path: ':type/leave',
        component: 'EventCalendarComponent',
        data: {
            selector: 'kx-event-calendar',
            type:'staff_leave_calendar'


        }
    }
    // {
    //     path:'crm_quotations_create_otc_invoice/:quotation_id/modify',
    //     component:'UiEngineComponent',
    //     data : {
    //         selector: 'app-ui-engine',
    //         nav_url: "permission_m",
    //         action: 'modify',
    //         resource:'crm_quotations_create_otc_invoice'
    //     }
    // }
        // {
        //     path: ':resource/:id//payment',
        //     component: 'ReviewOrderModalComponent',
        //     data: {
        //         selector: 'kx-review-order-modal'
        //     }
        // },
    ]


